import Api from '@/services/Api'

export default {
  generateScramble (sessionId, params) {
    return Api().put('session/' + sessionId + '/generate', params)
  },
  
  deleteScramble (sessionId, params) {
    return Api().put('session/' + sessionId + '/delete_scramble', params)
  }
}
